import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import { AuthLayout } from './layouts/AuthLayout';
import { AppLayout } from './layouts/AppLayout';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { RecipesPage } from './pages/RecipesPage';
import { RecipeDetailPage } from './pages/RecipeDetailPage';
import { MealsPage } from './pages/MealsPage';
import { AccountPage } from './pages/AccountPage';
import { FeedPage } from './pages/FeedPage';
import { FriendsList } from './components/FriendsList';
import { ProtectedRoute } from './components/ProtectedRoute';
import { RecipeImportPage } from './pages/RecipeImportPage';
import { RecipeImportModal } from './components/RecipeImportModal';
import { ErrorBoundary } from './components/ErrorBoundary';

function App() {
  const [showImportModal, setShowImportModal] = useState(false);
  const [recipeUrl, setRecipeUrl] = useState('');
  const [searchParams] = useSearchParams();


  useEffect(() => {
    const importUrl = searchParams.get('import');

    if (importUrl) {
      setRecipeUrl(importUrl);
      setShowImportModal(true);
    }
  }, [searchParams])

  return (
    <>
      <Routes>
        {/* Auth routes */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
        </Route>

        {/* Protected app routes */}
        <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
          <Route path="/feed" element={<FeedPage onImport={(url) => { setRecipeUrl(url); setShowImportModal(true) }} />} />
          <Route path="/recipes" element={<RecipesPage onImport={() => setShowImportModal(true)} />} />
          <Route path="/recipes/:id" element={<RecipeDetailPage />} />
          <Route path="/recipes/import" element={<RecipeImportPage />} />
          <Route path="/meals" element={<MealsPage />} />
          <Route path="/friends" element={<FriendsList />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/" element={<Navigate to="/feed" replace />} />
        </Route>
      </Routes>

      {/* Render modal at root level */}
      {showImportModal && (
        <ErrorBoundary>
          <RecipeImportModal sourceUrl={recipeUrl} onClose={() => { setShowImportModal(false); setRecipeUrl(''); }} />
        </ErrorBoundary>
      )}
    </>
  );
}

export default App;